// extracted by mini-css-extract-plugin
export default {"blur":"pages_blur__avtR0","header":"pages_header__lZapf","title":"pages_title__y5RwV","buttons":"pages_buttons__juqyn","activate-link":"pages_activate-link__z7iBt"};